import {
  Dispatch,
  FormEvent,
  SetStateAction,
  useCallback,
  useState,
} from "react"
import {
  Box,
  Button,
  FormControl,
  Text,
  Textarea,
  VStack,
} from "@chakra-ui/react"

import { usePosthogSurvey } from "#/shared/hooks"

type StoreItemFeedbackSurveyProps = {
  surveyCompleted: boolean
  setSurveyCompleted: Dispatch<SetStateAction<boolean>>
}

export default function StoreItemFeedbackSurvey({
  surveyCompleted,
  setSurveyCompleted,
}: StoreItemFeedbackSurveyProps) {
  const { survey, posthog } = usePosthogSurvey()

  const [feedback, setFeedback] = useState("")

  const surveySubmitHandler = useCallback(
    (e: FormEvent) => {
      if (!survey || !feedback) return

      e.preventDefault()

      const capturedResponse = posthog.capture("survey sent", {
        $survey_id: survey.id,
        $survey_response: feedback,
      })

      setSurveyCompleted(!!capturedResponse)
    },
    [posthog, feedback, survey, setSurveyCompleted],
  )

  if (!survey) return null

  return (
    <Box p="40px 50px">
      {surveyCompleted ? (
        <Text variant="bodyLarge" textAlign="center" py={10}>
          Thank you for your feedback!
        </Text>
      ) : (
        <form onSubmit={surveySubmitHandler}>
          <FormControl>
            <VStack>
              <Text variant="bodyLarge" textAlign="center">
                {survey.questions[0].question}
              </Text>
              <Textarea
                placeholder="Enter you response here"
                value={feedback}
                onChange={(e) => setFeedback(e.target.value)}
                resize="none"
                h="180px"
                p={4}
                my={4}
              />
              <Button
                variant="primary"
                size="large"
                onClick={surveySubmitHandler}
                w="240px"
              >
                Submit
              </Button>
            </VStack>
          </FormControl>
        </form>
      )}
    </Box>
  )
}
